import { Navigate } from "react-router-dom";
import { AppLayout } from "components/app-layout";
import {
  AgencySettingsProvider,
  type AgencySettingsLoaderData,
} from "contexts/agency-settings-provider";
import { RequireAuthRole } from "contexts/auth-provider";
import { queryClient } from "lib/react-query";
import type { Route } from "lib/react-router-dom";
import { AgencySettingsNavigationMenu } from "modules/agency-settings/components/agency-settings-navigation-menu/agency-settings-navigation-menu";
import { accountBrandingModel } from "modules/agency-settings/models/account-branding-model";
import { featurePreferencesModel } from "modules/agency-settings/models/feature-preferences-model";
import { AGENCY_SETTINGS_PATHS } from "modules/agency-settings/paths";
import { BrandingScreen } from "modules/agency-settings/screens/branding/branding-screen";
import { FeaturePreferenceScreen } from "modules/agency-settings/screens/feature-preferences/feature-preferences-screen";
import { VendorEmailScreen } from "modules/agency-settings/screens/vendor-email/vendor-email-screen";

export const AGENCY_SETTINGS_ROUTES: Route[] = [
  {
    path: AGENCY_SETTINGS_PATHS.DEFAULT,
    handle: {
      title: "Agency Settings",
    },
    loader: (): AgencySettingsLoaderData => {
      const preferencesData = queryClient.fetchQuery(
        featurePreferencesModel.queries.get(),
      );
      const brandingData = queryClient.fetchQuery(
        accountBrandingModel.queries.get(),
      );

      return {
        agencySettings: Promise.all([preferencesData, brandingData]).then(
          ([preferences, branding]) => {
            return {
              preferences,
              branding,
            };
          },
        ),
      };
    },
    element: (
      <RequireAuthRole anyOf={["agent_manager"]}>
        <AgencySettingsProvider>
          <AppLayout
            leftNavigationMenu={<AgencySettingsNavigationMenu />}
            hideListingSelector
          />
        </AgencySettingsProvider>
      </RequireAuthRole>
    ),

    children: [
      {
        index: true,
        Component: () => <Navigate to={AGENCY_SETTINGS_PATHS.BRANDING} />,
      },
      {
        path: AGENCY_SETTINGS_PATHS.BRANDING,
        Component: BrandingScreen,
        handle: {
          title: "Branding",
        },
      },
      {
        path: AGENCY_SETTINGS_PATHS.FEATURE_PREFERENCES,
        Component: FeaturePreferenceScreen,
        handle: {
          title: "Feature Preferences",
        },
      },
      {
        path: AGENCY_SETTINGS_PATHS.VENDOR_EMAIL,
        Component: VendorEmailScreen,
        handle: {
          title: "Rex Hub Login Email",
        },
      },
    ],
  },
];
